import { DEFAULT_LANGUAGE } from '../contexts/Language';

export default function localizedLink(to, language) {
    const localizedTo = language === DEFAULT_LANGUAGE ? to : `/${language}${to}`;
    return localizedTo
};
